import { useEffect, useState } from "react";

export function useDebounce<T>(value: T, delay = 500): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}

export function useOutsideClick<T extends HTMLElement>(
    ref: React.RefObject<T>,
    callback: () => void
) {
    useEffect(() => {
        const handler = (event: MouseEvent | TouchEvent) => {
            if (!ref.current) return;

            if (!ref.current.contains(event.target as Node)) {
                callback();
            }
        };

        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);

        return () => {
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [ref, callback]);
}
